import {isLogin, getUserCookie} from '@/utils/main';
import globalDomains from '@/utils/global-domains';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

export const loginState = typeof isLogin !== 'undefined' && isLogin();

/**
 * 로그인, 로그아웃 링크 이동
 * @param {}} event
 * @returns
 */
export const handleLogin = (event) => {
  if (!!window.afreeca.link) {
    const isMobile = window.afreeca.link.isMobile();

    const currentPageUrl = location.href;
    if (isMobile) {
      if (!loginState) {
        window.afreeca.link.goLogin(undefined, currentPageUrl);
        return;
      }

      window.afreeca.link.logout(currentPageUrl);
      return;
    }

    let url = `${globalDomains.LOGIN_AFREECATV}/afreeca/login.php?szFrom=full&request_uri=${encodeURIComponent(currentPageUrl)}`;

    if (loginState) {
      url = `${globalDomains.LOGIN_AFREECATV}/app/LogOut.php?request_uri=${currentPageUrl}`;
    }
    location.href = url;
    return false;
  }
};

/**
 * 유저 정보 가져오기
 * @return {{userNickname: (*|string), userId: (*|string)}}
 */
export const handleUserInfo = () => {
  const userNickname = getUserCookie('unick');
  const userId = getUserCookie('uid');

  return {
    userId: userId || '',
    userNickname: userNickname || '',
  };
};

export const handleCurrentFormatDate = (
  formmatPatter = 'YYYY-MM-DD HH:mm:ss',
) => {
  const currentDate = new Date();
  const parsedDate = dayjs(currentDate, 'YYYY-MM-DD HH:mm:ss');
  const formatDate = parsedDate.format(formmatPatter);

  return formatDate;
};

/**
 * store 구분자 값 (p: playstore, o: onestore, s: galaxy, etc: unknown or ios)
 * @return {string|boolean}
 */
export const inAppStore = () => {
  const userAgent = window.navigator.userAgent;

  const store = /store\/([a-zA-Z]+);?/gi.exec(userAgent) || '';

  return store ? store[1].toUpperCase() : false;
};

export const handleBrowserIap = (ppvParamUrl, ppvParamSku) => {
  if (!!window.afreeca.link) {
    window.afreeca.link?.browserIap(ppvParamUrl, ppvParamSku);
    return;
  }
};
